import React from 'react';
import {
    required,
    TextInput,
    SimpleForm,
    Create,
    SelectInput,
    DateInput,
    CardActions,
    ListButton,
    Toolbar,
    NumberInput,
    SaveButton,
    BooleanInput,
    ArrayInput,
    SimpleFormIterator,
} from 'react-admin';
import {RichTextInput} from 'ra-input-rich-text';
import withStyles from '@material-ui/core/styles/withStyles';
import TileCom from '../controls/TitleCom'
const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    td_border: {
        border: "1px solid",
        width: "25%"
    }
};


var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    // text direction
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
                                    // remove formatting button
  ];

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CheckListCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);


const CheckListCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);



const CheckListCreate = ({classes,...props }) => (
    <Create actions={<CheckListCreateActions />}   {...props}>
        <SimpleForm  toolbar={<CheckListCreateToolbar />}>
            <table style={{width:"99%"}} cellPadding="3">
            <tbody>
                <tr>
                    <td>Checklist Name:</td><td colSpan="3"><TextInput  source='name'  style={{width:"100%"}}  label=""  validate={required()}/></td>
                </tr>
                <tr>
                    <td>Trainee Name:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Center:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan="4">&nbsp;</td>
                </tr>
                <tr>
                    <td>Trainer Name:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Initial:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td>Trainer Name:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Initial:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td>Trainer Name:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Initial:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan="4">
                    <ArrayInput source="content1" label="">
                        <SimpleFormIterator>
                            <TextInput source="procedure" label="Procedure" multiline formClassName={classes.inlineBlock} style={{width:"25em"}}/>
                            <RichTextInput  source='referance'   label="Referance"  formClassName={classes.inlineBlock}   toolbar={toolbarOptions} />
                            <DateInput source="date_int" label="Date Introduced" locales="en-us" formClassName={classes.date} style={{width:"8em"}}/>
                            <TextInput source="trainer_init" label="Trainer Init" formClassName={classes.inlineBlock} style={{width:"8em"}} />
                            <TextInput source="trainee_init" label="Trainee Init" formClassName={classes.inlineBlock} style={{width:"8em"}}/>
                            <DateInput source="date_prof" label="Date Proficient" locales="en-us" formClassName={classes.date} style={{width:"8em"}}/>
                        </SimpleFormIterator>
                    </ArrayInput>
                    </td>
                </tr>
                <tr>
                    <td>Sub heading:</td><td colSpan="3"><TextInput  source='sub_heading'  style={{width:"100%"}}  label=""  /></td>
                </tr>
                <tr>
                    <td colSpan="4">
                    <ArrayInput source="content2" label="">
                        <SimpleFormIterator>
                            <TextInput source="procedure" label="Procedure" multiline formClassName={classes.inlineBlock} style={{width:"25em"}}/>
                            <RichTextInput  source='referance'   label="Referance"  formClassName={classes.inlineBlock}  toolbar={toolbarOptions}  />
                            <DateInput source="date_int" label="Date Introduced" locales="en-us" formClassName={classes.date} style={{width:"8em"}}/>
                            <TextInput source="trainer_init" label="Trainer Init" formClassName={classes.inlineBlock} style={{width:"8em"}} />
                            <TextInput source="trainee_init" label="Trainee Init" formClassName={classes.inlineBlock} style={{width:"8em"}}/>
                            <DateInput source="date_prof" label="Date Proficient" locales="en-us" formClassName={classes.date} style={{width:"8em"}}/>
                        </SimpleFormIterator>
                    </ArrayInput>
                    </td>
                </tr>
                <tr>
                    <td>Trainee Signature:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td>Center Manager Signature:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td>Quality Assurance Signature:</td><td className={classes.td_border}>&nbsp;</td>
                    <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
                </tr>
                <tr>
                    <td>Is Active?</td>
                    <td colSpan="3"><BooleanInput source="isactive" label="" /></td>
                </tr>
                <tr>
                    <td >Role/ Title: </td>
                    <td colSpan="3"><TileCom props={props}  source="roles"  label = " " /></td>
                </tr>
                <tr>
                    <td colSpan="4"><hr /></td>
                </tr>
                <tr>
                    <td colSpan="4"><h4>TRAINING FORM</h4></td>
                </tr>
                <tr>
                    <td>Form heading:</td><td colSpan="3"><TextInput  source='form_heading'  style={{width:"100%"}}  label=""  /></td>
                </tr>
                <tr>
                    <td >Trainee Name:</td><td colSpan="2" className={classes.td_border}>&nbsp;</td>
                    <td></td>
                </tr>
                <tr>
                </tr>
            </tbody>
            </table>
            <ArrayInput source="forms" label="Table" style={{width:"100%"}}>
                <SimpleFormIterator>
                    <TextInput source="form_subheading" label="Form Sub heading"  style={{width:"100%"}} />
                    <NumberInput source="num_rows" label="Number of rows" required />
                    <ArrayInput source="form_fields" label="Field heading">
                        <SimpleFormIterator>
                        <TextInput source="field_name" label="Field Name" />
                        <NumberInput source="field_size" label="Field Size"  required/>
                        </SimpleFormIterator>
                    </ArrayInput>
                </SimpleFormIterator>
            </ArrayInput>
            <table style={{width:"99%"}} cellPadding="3">
            <tbody>
            <tr>
                <td>Trainee Signature:</td><td className={classes.td_border}>&nbsp;</td>
                <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
            </tr>
            <tr>
                <td>Quality Assurance Signature:</td><td className={classes.td_border}>&nbsp;</td>
                <td>Date:</td><td className={classes.td_border}>&nbsp;</td>
            </tr>
            <tr>
                <td >Form footer:</td>
                <td colSpan="3"><TextInput source="form_footer" label=""  fullWidth /></td>
            </tr>
            </tbody>
            </table>

            </SimpleForm>
    </Create>
);

export default withStyles(editStyles)(CheckListCreate);
